import React, { Component } from 'react'
import './table.css'

import {
	CSSTransition,
	TransitionGroup,
} from 'react-transition-group';

class Table extends Component {

	render() {

		const { selected, sidemenu } = this.props;

		const renderItems = () => {
			return (
				selected.map((bank) => (

					<CSSTransition
						key={bank.id}
						timeout={600}
						classNames="fade"
					>
						<div className="selected-bank" key={bank} >

							<div className="row row1">
								<img src={bank.establissement} alt={bank.alt} />
							</div>

							<div className="row row2">
								<p>{bank.name}</p>
							</div>

							<div className="row row3">
								{bank.cardtype.map((nestItem, index) => (
									<p key={index} >{nestItem}</p>
								))}
							</div>

							<div className="row row4 visuel">
								{bank.visuel.map((nestItem, index) => (
									<div className="row__nested" key={index}>
										<img src={nestItem} alt={bank.alt} />
									</div>
								))}
							</div>

							<div className="row row5">
								{bank.price.map((priceNest, index) => (
									<div className="row__nested row--column" key={index}>
										{priceNest.map((nestItem, index) => <div key={index}>{nestItem}</div>)}
									</div>
								))}
							</div>

							<div className="row row6 ">
								{bank.retirable.map((nestItem, index) => (
									<p key={index} >{nestItem}</p>
								))}
							</div>

							<div className="row row7">
								{bank.netRevenue.map((item, index) => (
									<div className="row--column" key={index}>
										<div className="row--column center-horizontal">
											<div>
												{item.row1}
												<br />
												<span className="fz-14">{item.row2}</span>
											</div>
											<div>
												{item.row3}
												<br />
												<span className="fz-14">{item.onlySmallTxt}</span>
											</div>
											<div>
												{item.row4}
												<br />
												<span className="fz-14">{item.row5}</span>
											</div>
										</div>
									</div>
								))}
							</div>

							<div className="row row8">
								{bank.mandatory.map((nestItem, index) => (
									<div key={index} className="row--column center-horizontal">
										{nestItem.row1green ?
											<div className="green">{nestItem.row1green}</div>
											:
											<div>{nestItem.row1}</div>
										}
										<div>{nestItem.row2}</div>
									</div>
								))}
							</div>
							<div className="row row9 ">
								{bank.debit.map((nestItem, index) => (
									<p key={index} >{nestItem}</p>
								))}
							</div>
							<div className="row row10 ">
								{bank.week.map((nestItem, index) => (
									<p key={index} >{nestItem}</p>
								))}
							</div>
							<div className="row row11 ">
								{bank.month.map((nestItem, index) => (
									<p key={index} >{nestItem}</p>
								))}
							</div>
							<div className="row row12 ">
								{bank.decouvert.map((nestItem, index) => (
									<p key={index} >{nestItem}</p>
								))}
							</div>
							<div className="row row13 ">
								<p>{bank.taux}</p>
							</div>
							<div className="row row13 ">
								<p>{bank.tauxNon}</p>
							</div>

							<div className="row row14 ">
								<p>{bank.code}</p>
							</div>
							<div className="row row15 ">
								<p>{bank.ecb}</p>
							</div>
							<div className="row row16 ">
								<p>{bank.nfc}</p>
							</div>
							<div className="row row17 ">
								<p>{bank.recharg}</p>
							</div>
							<div className="row row18 ">
								{bank.comm.map((nestItem, index) => (
									<p key={index} className="brdr-right center-horizontal" >{nestItem}</p>
								))}
							</div>
							<div className="row row19 ">
								<p>{bank.chequier}</p>
							</div>
							<div className="row row20 ">
								<p>{bank.cheque}</p>
							</div>
							<div className="row row21 ">
								<p>{bank.depotCheq}</p>
							</div>
							<div className="row row22 ">
								<p>{bank.depotEspeces}</p>
							</div>
							<div className="row row23">
								<div> {bank.delai.row1}<br />{bank.delai.row2}</div>
							</div>
							<div className="row row24 ">
								<p>{bank.limitation}</p>
							</div>
							<div className="row row25 row--column">
								{bank.parrainage.map((nestItem, index) => (
									<div key={index} >{nestItem}</div>
								))}
							</div>
							<div className="row row26 ">
								<p>{bank.assurances}</p>
							</div>
							<div className="row row27 ">
								<p>{bank.changement}</p>
							</div>
							<div className="row row28 row--column">
								{bank.produit.map((nestItem, index) => (
									<div key={index} >{nestItem}</div>
								))}
							</div>
							<div className="row row29 ">
								{bank.plusHFR.map((nestItem, index) => (
									<p key={index} >{nestItem}</p>
								))}
							</div>
							<div className="row row30 row--column">
								{bank.minusHFR.map((nestItem, index) => (
									<div key={index} >{nestItem}</div>
								))}
							</div>
							<div className="row row31 ">
								<div>{bank.horaires}</div>
							</div>
							<div className="row row32 row--column ">
								{bank.numero.map((nestItem, index) => (
									<div key={index} className="center-horizontal" >{nestItem}</div>
								))}
							</div>

						</div>

					</CSSTransition>


				))

			)
		}


		return (
			<div className="table">


				<div className="tableWrap__left">
					<div className="row row1">{sidemenu.row1}</div>
					<div className="row row2">{sidemenu.row2}</div>
					<div className="row row3">{sidemenu.row3}</div>
					<div className="row row4">{sidemenu.row4}</div>
					<div className="row row5 row--column">
						<div>{sidemenu.row5A}</div>
						<div>{sidemenu.row5B}</div>
					</div>

					<div className="row row6">

						<div>
							{sidemenu.row6} <br />
							<span className="sky">{sidemenu.row6A}</span>
						</div>

					</div>

					<div className="row row7 row--column">
						<div>{sidemenu.row7A}</div>
						<div className="text-center">{sidemenu.row7B}</div>
						<div>{sidemenu.row7C}
							<br />
							<span className="sky">{sidemenu.row7D}</span>
						</div></div>

					<div className="row row8 row--column">
						<div>{sidemenu.row8A}</div> <div>{sidemenu.row8B}</div>
					</div>
					<div className="row row9">
						<p>{sidemenu.row9}</p>
					</div>
					<div className="row row10">
						<p>{sidemenu.row10}</p>
					</div>
					<div className="row row11">
						<p>{sidemenu.row11}</p>
					</div>
					<div className="row row12">
						<p>{sidemenu.row12}</p>
					</div>
					<div className="row row13">
						<p>{sidemenu.row13}</p>
					</div>
					<div className="row row13 row13-a">
						<p>{sidemenu.row13A}</p>
					</div>
					<div className="row row14">
						<p>{sidemenu.row14}</p>
					</div>
					<div className="row row15">
						<p>{sidemenu.row15}</p>
					</div>
					<div className="row row16">
						<p>{sidemenu.row16}</p>
					</div>
					<div className="row row17">
						<p>{sidemenu.row17}</p>
					</div>
					<div className="row row18">
						<p>{sidemenu.row18}</p>
					</div>
					<div className="row row19">
						<p>{sidemenu.row19}</p>
					</div>
					<div className="row row20">
						<p>{sidemenu.row20}</p>
					</div>
					<div className="row row21">
						<p>{sidemenu.row21}</p>
					</div>
					<div className="row row22">
						<p>{sidemenu.row22}</p>
					</div>
					<div className="row row23">
						<p>{sidemenu.row23}</p>
					</div>
					<div className="row row24">
						<p>{sidemenu.row24}</p>
					</div>
					<div className="row row25 row--column">
						<div>{sidemenu.row25A}</div>
						<div>{sidemenu.row25B}</div>
					</div>
					<div className="row row26">
						<p>{sidemenu.row26}</p>
					</div>
					<div className="row row27">
						<p>{sidemenu.row27}</p>
					</div>
					<div className="row row28">
						<p>{sidemenu.row28}</p>
					</div>
					<div className="row row29">
						<p>{sidemenu.row29}</p>
					</div>
					<div className="row row30">
						<p>{sidemenu.row30}</p>
					</div>
					<div className="row row31">
						<p>{sidemenu.row31}</p>
					</div>
					<div className="row row32">
						<p>{sidemenu.row32}</p>
					</div>

				</div>

				<div className="tableWrap__right">
					<TransitionGroup component={null}>
						{
							!selected.length ?
								<CSSTransition
									key="123"
									timeout={600}
									classNames="fade"
								>

									<h3>{sidemenu.tableTitle}</h3>
								</CSSTransition>
								:
								renderItems()}
					</TransitionGroup>
				</div>


			</div>
		)

	}
}

export default Table


// WEBPACK FOOTER //
// ./src/components/Table/Table.jsx